<template>
	<div class="overflow-hidden flex flex-col justify-between min-w-32 md:min-w-64 pb-4">
		<img
			class="w-full rounded-2xl"
			:alt="props.data.title"
			:src="props.data.image"
		/>

		<div class="bg-accent-green-0.25 p-4 pt-3 rounded-2xl mt-2 h-full">
			<div class="h-full flex flex-col">
				<div class="flex flex-row justify-between items-center">
					<div class="text-vc-body font-medium">
						{{ props.data.title }}
					</div>
					<div class="text-vc-body text-gray">
						<div class="text-black">${{ props.data.precio }}</div>
					</div>
				</div>

				<div class="text-vc-small leading-tight">
					{{ props.data.tag }}
				</div>

				<div
					v-if="props.tag"
					class="text-vc-small xl:h-28 pt-4 leading-tight"
				>
					{{ props.data.text }}
				</div>
			</div>
		</div>

		<div
			v-if="props.showButton"
			class="rounded-2xl mt-2"
			@click="handleClick"
		>
			<div
				class="bg-accent-red text-white w-full py-2 px-4 text-center cursor-pointer rounded-2xl hover:bg-accent-red-dark font-medium"
			>
				¡QUIERO!
			</div>
		</div>
	</div>
</template>

<script>
import { trackQuieroButtonClick } from '@/services/facebookAnalytics'

export default {
	name: 'ClubComponent',
	props: {
		data: {
			type: Object,
			required: true
		},
		showButton: {
			type: Boolean,
			default: false
		},
		handler: {
			type: Function,
			required: true
		},
		tag: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const handleClick = () => {
			try {
				trackQuieroButtonClick(props.data)
			} catch (e) {
				console.error('Error tracking quiero button click:', e)
			}
			props.handler(props.data)
		}

		return {
			props,
			handleClick
		}
	}
}
</script>
